import React, { useEffect, useState } from "react";
import { Loader2, Star, Eye, EyeOff } from "lucide-react";
import { AdminLayout } from "./AdminLayout";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";

export default function AdminReviews() {
  const [reviews, setReviews] = useState(null);
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  useEffect(() => { load(); }, []);

  const toggle = async (r) => { await api.put(`/admin/reviews/${r.id}`); load(); };

  return (
    <AdminLayout>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900">Reviews</h1>
      {reviews === null ? <div className="flex justify-center py-20"><Loader2 className="animate-spin text-slate-400" /></div> :
        reviews.length === 0 ? <p className="mt-6 text-slate-500">Nog geen beoordelingen.</p> : (
          <div className="mt-6 space-y-3">
            {reviews.map((r) => (
              <div key={r.id} className="bg-white border border-slate-200 rounded-xl p-5 flex items-start justify-between gap-4" data-testid={`admin-review-${r.id}`}>
                <div>
                  <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={16} className={i <= r.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"} />)}</div>
                  <p className="mt-2 text-slate-700">"{r.comment}"</p>
                  <p className="mt-1 text-xs text-slate-400">{r.customer_name} · {r.city} · {r.booking_number}</p>
                </div>
                <Button size="sm" variant="outline" onClick={() => toggle(r)} data-testid={`toggle-review-${r.id}`}>
                  {r.approved ? <><Eye size={14} className="mr-1" /> Zichtbaar</> : <><EyeOff size={14} className="mr-1" /> Verborgen</>}
                </Button>
              </div>
            ))}
          </div>
        )}
    </AdminLayout>
  );
}
